import { ArrowDown } from '@App/static/icons/DashboardIcons'

import s from './styles.module.scss'

import DateRangePicker from 'rsuite/DateRangePicker'

import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

import cn from 'clsx'

import 'rsuite/DateRangePicker/styles/index.css'

import { format, isSameMonth, isSameYear } from 'date-fns'
import { enUS } from 'date-fns/locale'

import { BodyPortal } from '@App/ui/crypto_exchange/desktop/components/common/BodyPortal'
import OutsideClickComponent from '@App/ui/crypto_exchange/desktop/components/common/OutsideClickHandler'

type Pos = { top: number; left: number; width: number }
type DateRange = {
  from: Date
  to: Date | null
}

const formatDateRange = (range: DateRange, opts?: { locale?: Locale }) => {
  if (!range.to) {
    return ''
  }
  const locale = opts?.locale ?? enUS

  const { from, to } = range

  if (isSameMonth(from, to) && isSameYear(from, to)) {
    return `${format(from, 'd', { locale })} – ${format(to, 'd MMM', { locale })}`
  }

  if (isSameYear(from, to)) {
    return `${format(from, 'd MMM', { locale })} – ${format(to, 'd MMM', { locale })}`
  }

  return `${format(from, 'd MMM yyyy', { locale })} – ${format(to, 'd MMM yyyy', { locale })}`
}

export const CustomDateTab = ({
  isActive,
  value,
  setValue,
  resetDate,
  setPrevTab,
}: {
  isActive: boolean
  value: DateRange
  setValue: (val: DateRange) => void
  resetDate: () => void
  setPrevTab: () => void
}) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false)
  const wrapRef = useRef<HTMLDivElement | null>(null)
  const triggerRef = useRef<HTMLDivElement | null>(null)
  const [pos, setPos] = useState<Pos>({ top: 0, left: 0, width: 0 })

  const updatePos = useCallback(() => {
    const el = triggerRef.current
    if (!el) return

    const r = el.getBoundingClientRect()
    setPos({
      top: r.bottom + 15,
      left: r.left - 200,
      width: r.width,
    })
  }, [])

  useEffect(() => {
    if (!isActive) {
      //resetDate()
      setIsPickerOpen(false)
      return
    }
    setIsPickerOpen(true)
  }, [isActive])
  useLayoutEffect(() => {
    if (isPickerOpen) updatePos()
  }, [isPickerOpen])

  const handleDateSubmit = (val: DateRange) => {
    setValue(val)
    setIsPickerOpen(false)
  }
  const handleTabClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (wrapRef.current?.contains(e.target as Node)) return
    setIsPickerOpen((p) => !p)
  }
  const handleClickOutSide = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target
    if (!(target instanceof Node)) return

    if (triggerRef.current?.contains(target)) return

    setIsPickerOpen(false)
    if (!value.to) {
      setPrevTab()
    }
  }
  return (
    <div ref={triggerRef} className={cn(s.container, isPickerOpen && s.active)} onClick={handleTabClick}>
      {value.to && isActive ? formatDateRange(value) : 'Custom'} <ArrowDown className={s.arrowIcon} />
      {isPickerOpen && isActive && (
        <DateRangePicker
          className={s.rsPicker}
          popupStyle={{
            position: 'relative',
            left: 0,
            top: 0,
          }}
          defaultValue={[value.from, value.to] as [Date, Date]}
          onOk={(value) => {
            handleDateSubmit({ from: value.at(0)!, to: value.at(1)! })
          }}
          open={isPickerOpen}
          container={() => wrapRef.current!}
          top={pos.top}
          left={pos.left}
        />
      )}
      <BodyPortal>
        {isPickerOpen && isActive && (
          <OutsideClickComponent handler={handleClickOutSide}>
            <div
              ref={wrapRef}
              className={s.pickerContainer}
              style={{
                top: pos.top,
                left: pos.left,
              }}
            />
          </OutsideClickComponent>
        )}
      </BodyPortal>
    </div>
  )
}
